/**
 * Hides the redundant PeachPay submenu that appears when hovered on the PeachPay menu item when outside the PeachPay settings.
 */
function correctWordpressSubmenu() {
	// Remove extra link that should not be present.
	document.querySelector('a[href="admin.php?page=peachpay"].wp-first-item')?.parentElement?.remove();

	// Mark the actual link that is active as active.
	document.querySelector(`a[href="admin.php${window.location.search}"]`)?.parentElement?.classList.add('current');
}

document.addEventListener('DOMContentLoaded', () => {
	correctWordpressSubmenu();
});
